module.exports = __webpack_public_path__ + "66233b8704aa44596bcb8b2d67b7b56d.png";